module.exports = __webpack_public_path__ + "img/flag-usa.d8888612.png";